<template>
  <span class="px-2 py-0.5 text-xs rounded whitespace-nowrap" :class="pillClass">
    {{ label }}
  </span>
</template>

<script setup>
import { defineProps, computed } from "vue";

const props = defineProps({
  status: { type: String, required: true },
});

const labels = {
  draft: "Draft",
  submitted: "Pending Manager",
  manager_approved: "Pending Accounting",
  accounting_approved: "Approved",
  closed: "Closed",
  rejected: "Rejected",
};

const classes = {
  draft: "bg-gray-200 text-gray-700",
  submitted: "bg-yellow-100 text-yellow-800",
  manager_approved: "bg-blue-100 text-blue-800",
  accounting_approved: "bg-green-100 text-green-800",
  closed: "bg-green-200 text-green-900",
  rejected: "bg-red-100 text-red-800",
};

const label = computed(() => labels[props.status] || props.status);
const pillClass = computed(() => classes[props.status] || "bg-gray-200 text-gray-700");
</script>
